<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="item-header">
    <div class="back-container" @click="backHandler">
      <div class="back-icon" />
      <div class="back-text">{{ $t('back') }}</div>
    </div>
    <div class="buttons-container">
      <div
        v-if="isLogged"
        class="btn--light btn--circle"
        :class="favChecked && 'fav-check'"
        @click="toggleFavCheck"
      >
        <div class="btn-icon--favor" />
      </div>
      <div class="btn btn--light " :class="isMobile ? 'btn--circle' : 'btn--small'" @click="show">
        <div class="btn-icon btn-icon--share" />
        <div v-if="!isMobile" class="btn-text">{{ $t('share') }}</div>
      </div>
      <ModalShare :modal-close="hide" :data-title="dataCard.title" />
    </div>
  </div>
</template>

<script>
import ModalShare from '../modals/ModalShare.vue'
import { deleteUserFav, createUserFav } from '@/services/user-api'
/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'ItemHeader',
  components: { ModalShare },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
    dataFavs: {
      type: Array,
    },
    reloadDataCard: {
      type: Function,
    },
  },
  data() {
    return {
      // favId: null
    }
  },
  computed: {
    favChecked: {
      get() {
        let fav = false
        if(this.dataFavs.length !== 0) {
          this.dataFavs.forEach(el => {
            if (!el.payload) {
              fav = true
            }
          })
        }
        return fav
      },
    },
    isLogged() {
      return this.$store.state.user.isLogged
    },
    favId: {
      get() {
        let fav = null
        if(this.dataFavs.length !== 0) {
          this.dataFavs.forEach(el => {
            if (!el.payload) {
              fav = el.favouriteId
            }
          })
        }
        return fav
      },
    }
  },
  watch: {
    
  },
  methods: {
    toggleFavCheck() {
      if (this.favChecked) {
        deleteUserFav(this.favId).then(resp => {
          if (resp.code === 200) {
            this.reloadDataCard()
          }
        })
      } else {
        createUserFav(this.$route.params.cardId, '').then(resp => {
          if (resp.code === 200) {
            this.reloadDataCard()
          }
        })
      }
      
    },
    /**
     * Navigate to home page or go back 1 page of history if it exist
     * @public This is a public method
     */
    backHandler: function () {
      if (window.history.length > 2) {
        this.$router.back()
      } else this.$router.push('/')
    },
    /**
     * Shows the modal "modal-share"
     * @public This is a public method
     */
    show() {
      this.$modal.show('modal-share', { url: window.location.href.split('?')[0], dataTitle: this.dataCard.title })
    },
    /**
     * Hide the modal "modal-share"
     * @public This is a public method
     */
    hide() {
      this.$modal.hide('modal-share')
    },
  },
}
</script>

<style lang="stylus" scoped>
.item-header
  position: relative
  display: flex
  justify-content: space-between
  margin-bottom: vw(20px)
  width: 100%

.back-container
  display: flex
  align-items: center
  cursor: pointer

  &:hover
    .back-text
      font-weight: 600

.back-icon
  m-icon("arrow-back", 22)
  margin-right: vw(5px)

.back-text
  m-font-size(18, 20)
  color: $grey-dark

.buttons-container
  display: flex
  align-items: center
  gap: vw(15px)

.button-container
  m-font-size(14, 20)
  display: flex
  align-items: center
  padding: vw(5px) vw(10px)
  border: 1px solid $grey-dark
  border-radius: 3px
  cursor: pointer
  gap: vw(5px)

  &:hover
    background-color: $bcn-grey

  .button-icon
    &.download
      m-icon("arrow-downward", 16, $black)

    &.share
      m-icon("share", 16, $black)

  .button-text
    color: $grey-dark

.btn--circle
  display: flex
  justify-content: center
  align-items: center
  padding: 0
  width: vw(36px)
  height: vw(36px)
  border: 1px solid $grey-grey
  border-radius: 50%
  cursor: pointer

  &:hover
    border: 1px solid $grey-grey

  &.fav-check
    background-color: $grafics-yellow !important

    .btn-icon--favor
      background-color: black

.btn-icon--favor
  m-icon("star-active", 20)
</style>